import React, { useState } from 'react';
import './Donation.css';

const GIVING_TYPES = [
  { id: 'dime', icon: '🙏', label: 'Dîme', description: '10% de vos revenus — un acte de foi et d\'obéissance à Dieu.' },
  { id: 'offrande', icon: '💝', label: 'Offrande', description: 'Un don volontaire pour le soutien général de l\'église.' },
  { id: 'missions', icon: '🌍', label: 'Missions', description: 'Soutenir nos missionnaires et l\'évangélisation en Haïti.' },
  { id: 'special', icon: '⭐', label: 'Don Spécial', description: 'Construction, équipement ou projets spéciaux de l\'église.' },
];

const METHODS = [
  {
    title: 'MonCash / Digicel',
    icon: '📱',
    color: '#e63946',
    lines: [
      'Numéro : +509 4888-0000',
      'Nom : Première Église Chrétienne De La Chambre Haute',
      'Envoyez votre don via l\'app MonCash',
    ],
  },
  {
    title: 'Natcash / NatBank',
    icon: '🏦',
    color: '#1B3A6B',
    lines: [
      'Numéro de compte : 0123-4567-8910',
      'Banque : BNC Haïti',
      'Au nom de : Première Église Chrétienne De La Chambre Haute',
    ],
  },
  {
    title: 'Diaspora — Zelle',
    icon: '💸',
    color: '#6a0dad',
    lines: [
      'Zelle : contact@miprecch.com',
      'Note : Précisez le type de don',
    ],
  },
];

export default function Donation() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="donation-page">
      {/* Page Banner */}
      <section className="page-banner">
        <div className="container">
          <h1 className="page-banner__title">Faire un Don</h1>
          <p className="page-banner__sub">
            « Que chacun donne selon ce qu'il a résolu en son cœur, sans tristesse ni contrainte; car Dieu aime celui qui donne avec joie. »
            <span className="page-banner__ref"> — 2 Corinthiens 9:7</span>
          </p>
        </div>
      </section>

      <div className="container donation-container">

        {/* Why Give */}
        <section className="donation-intro">
          <h2>Pourquoi Donner ?</h2>
          <p>
            Votre générosité permet à la Première Église Chrétienne De La Chambre Haute de poursuivre sa mission — adorer Dieu,
            bâtir des disciples et servir les communautés de Saint-Marc et au-delà.
            Chaque don, grand ou petit, fait une différence éternelle.
          </p>
        </section>

        {/* Giving Types */}
        <section className="donation-section">
          <h2 className="donation-section__title">Type de Don</h2>
          <div className="giving-types">
            {GIVING_TYPES.map((g) => (
              <button
                key={g.id}
                className={`giving-type-card${selected === g.id ? ' giving-type-card--active' : ''}`}
                onClick={() => setSelected(g.id)}
              >
                <span className="giving-type-card__icon">{g.icon}</span>
                <h3 className="giving-type-card__label">{g.label}</h3>
                <p className="giving-type-card__desc">{g.description}</p>
              </button>
            ))}
          </div>
        </section>

        {/* Payment Methods */}
        <section className="donation-section">
          <h2 className="donation-section__title">Comment Donner</h2>
          <div className="payment-methods">
            {METHODS.map((m) => (
              <div key={m.title} className="payment-card" style={{ '--method-color': m.color }}>
                <div className="payment-card__header">
                  <span className="payment-card__icon">{m.icon}</span>
                  <h3 className="payment-card__title">{m.title}</h3>
                </div>
                <ul className="payment-card__lines">
                  {m.lines.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Assurance */}
        <section className="donation-assurance">
          <div className="assurance-inner">
            <span className="assurance-icon">🔒</span>
            <div>
              <h3>Vos Dons Sont Bien Gérés</h3>
              <p>
                La Première Église Chrétienne De La Chambre Haute s'engage à une gestion transparente et responsable de tous les
                dons reçus. Un rapport financier annuel est disponible sur demande auprès du bureau
                de l'église.
              </p>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}
